<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    destroyOnClose
    :visible="visible"
  >
    <!-- <chat-dialog @close="close" /> -->
    <HomeIndex @close="close" />
  </a-drawer>
</template>

<script>
// import ChatDialog from './ChatDialog.vue'
import HomeIndex from './HomeIndex.vue'

export default {
  name: 'ChatDrawer',
  components: { HomeIndex },
  data() {
    return {
      title: 'iPlus知识问答',
      width: 800,
      visible: false,
      disableSubmit: false
    }
  },
  methods: {
    showDrawer() {
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>

.chat-box {
  .ant-drawer-body {
    padding: 0;
  }
  // .ant-drawer-content-wrapper {
  //   height: 100%;
  //   .ant-drawer-content {
  //     height: 100%;
  //     .ant-drawer-wrapper-body {
  //       height: 100%;
  //       .ant-drawer-body {
  //         height: 100%;
  //         padding: 0;
  //       }
  //     }
  //   }
  // }
}
.chat-box {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 2px;
  overflow: hidden;
  .chat-box-header {
    padding: 10px 20px;
    border-bottom: 1px solid #e8e8e8;
    .chat-box-title {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .chat-box-body {
    padding: 10px 20px;
    height: calc(100% - 50px);
    overflow-y: auto;
  }
  .chat-box-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 20px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
}

/** Button按钮间距 */
// .ant-btn {
//   margin-left: 30px;
//   margin-bottom: 30px;
//   float: right;
// }
.drawer-footer {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

</style>
